import { useState, useEffect } from "react";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { Dialog, DialogPanel } from "@headlessui/react";
import { Bars3Icon, XMarkIcon } from "@heroicons/react/24/outline";
import {
  faFileCirclePlus,
  faFilePen,
  faUserGear,
  faUserPlus,
  faRightFromBracket,
} from "@fortawesome/free-solid-svg-icons";
import {
  useNavigate,
  Link,
  useLocation,
  useSearchParams,
} from "react-router-dom";
// import { useSendLogoutMutation } from "../features/auth/authApiSlice";
import Login from "../features/auth/Login";
import Register from "../features/auth/Register";
// import { selectTabTrigger,setTabTrigger } from "../features/transformacije/PokreniTransformaciju";
// import { selectmodalTrigger,setmodalTrigger } from "./TransitionSlice";
import { useSelector, useDispatch } from "react-redux";
import { setmodalTrigger, selectmodalTrigger } from "./TransitionSlice";
import Email from "../features/auth/Email";

const LandingHeader = ({
  onScrollToMiddle,
  onScrollToMiddleMobile,
  onScrollPrica,
  onScrollPricaMobile,
  onScrollToPomoc,
  onScrollToPomocMobile,
}) => {
  // const { isManager, isAdmin } = useAuth();
  // const modalTrigger = useSelector(selectmodalTrigger);
  const navigate = useNavigate();
  const blogsPublic = () => navigate("/blogsPublic");
  const [searchParams] = useSearchParams();

  const [isScrolled, setIsScrolled] = useState(false);

  const dispatch = useDispatch();
  const { modalTrigger } = useSelector((state) => state.tranzicijaData);

  const [showModal, setShowModal] = useState(false);
  const [showModalRegister, setShowModalRegister] = useState(false);

  const [mobileMenuOpen, setMobileMenuOpen] = useState(false);

  const location = useLocation();
  const params = new URLSearchParams(location.search);
  const showLogin = params.get("showLogin");

  //Za login modal
  const openModal = () => {
    setMobileMenuOpen(false);
    setShowModal(true);
  };

  useEffect(() => {
    if (showLogin === "true") {
      openModal();
    }
  }, [showLogin]);

  const closeModal = () => setShowModal(false);

  //Za register modal
  const openModalRegister = () => {
    setMobileMenuOpen(false);
    setShowModalRegister(true);
  };

  const closeModalRegister = () => setShowModalRegister(false);

  const handleOverlayClick = (e) => {
    if (e.target.id === "modal-overlay") {
      closeModal();
      closeModalRegister();
    }
  };

  //Za scroll
  const handleScroll = () => {
    // Ako je pozicija skrolovanja veća od 50px, postavljamo state na true
    if (window.scrollY > 50) {
      setIsScrolled(true);
    } else {
      setIsScrolled(false);
    }
  };

  useEffect(() => {
    // Dodajemo event listener za skrolovanje
    window.addEventListener("scroll", handleScroll);

    // Čistimo event listener kada komponenta bude uklonjena
    return () => {
      window.removeEventListener("scroll", handleScroll);
    };
  }, []);

  // const { pathname } = useLocation();

  // const [sendLogout, { isLoading, isSuccess, isError, error }] =
  //   useSendLogoutMutation();

  // useEffect(() => {
  //   if (isSuccess) navigate("/");
  // }, [isSuccess, navigate]);

  //Proverava i menja iz register u login
  useEffect(() => {
    if (modalTrigger == true) {
      dispatch(setmodalTrigger(!modalTrigger));
      closeModalRegister();
      openModal();
    }
  }, [modalTrigger]);

  const navigation = [
    { name: "Priča", href: "#" },
    { name: "Blog", href: "#" },
    { name: "Pomoć", href: "#" },
  ];

  let ScrollDown = () => {
    setTimeout(() => {
      window.scrollTo(0, document.body.ScrollDown);
    }, 100);
  };

  //Za mobile fukcije
  const scrollToBlogMobile_ = () => {
    setMobileMenuOpen(false);
    handleScrollAndNavigate("blog");
  };

  const scrollToPricaMobile_ = () => {
    setMobileMenuOpen(false);
    handleScrollAndNavigate("prica");
  };

  //nepostoji jos
  const scrollToPomocMobile_ = () => {
    setMobileMenuOpen(false);
    handleScrollAndNavigate("pomoc");
  };

  //Navigiram na Public starnicu i silazim do anchora!
  const handleScrollAndNavigate = (sectionId) => {
    navigate("/");

    setTimeout(() => {
      const element = document.getElementById(sectionId);
      if (element) {
        element.scrollIntoView({ behavior: "smooth" });
      }
    }, 100);
  };

  return (
    <>
      <header
        className={`fixed inset-x-0 top-0 z-50 ${
          isScrolled ? "bg-custom-green" : "bg-transparent"
        }`}
      >
        <nav
          className="mx-auto flex w-full items-center justify-between p-3 lg:px-8"
          aria-label="Global"
        >
          <div className="flex lg:flex-1">
            <a href="https://nutritrans.rs/" className="-m-2 flex-shrink-0">
              <img
                className="w-10"
                src={`${process.env.PUBLIC_URL}/logoo.png`}
                alt="Your Company"
              />
            </a>
          </div>
          <div className="flex lg:hidden">
            {/* Custom smaller hamburger button */}
            <button
              type="button"
              className="absolute top-4 right-4 z-50 p-1 rounded-md text-gray-700"
              onClick={() => setMobileMenuOpen(true)}
            >
              {/* Hamburger Icon */}
              {!mobileMenuOpen && (
                <div
                  style={{
                    display: "flex",
                    flexDirection: "column",
                    gap: "3px",
                  }}
                >
                  <div
                    style={{
                      height: "2px",
                      width: "20px",
                      backgroundColor: "black",
                    }}
                  />
                  <div
                    style={{
                      height: "2px",
                      width: "20px",
                      backgroundColor: "black",
                    }}
                  />
                  <div
                    style={{
                      height: "2px",
                      width: "20px",
                      backgroundColor: "black",
                    }}
                  />
                </div>
              )}
            </button>
          </div>
          <div className="hidden lg:flex lg:gap-x-12">
            {/* Navigation items */}
          </div>
          <div className="hidden lg:flex flex-1 items-center justify-end gap-x-6">
            <button
              // onClick={onScrollPrica}
              onClick={() => handleScrollAndNavigate("prica")}
              className="hidden lg:block lg:text-sm lg:font-semibold lg:leading-6 lg:text-gray-900"
            >
              Priča
            </button>
            <button
              onClick={onScrollToMiddle}
              // onClick={() => handleScrollAndNavigate("blog")}
              className="hidden lg:block lg:text-sm lg:font-semibold lg:leading-6 lg:text-gray-900"
            >
              Blog
            </button>
            <button
              // onClick={onScrollToPomoc}
              onClick={() => handleScrollAndNavigate("pomoc")}
              className="hidden lg:block lg:text-sm lg:font-semibold lg:leading-6 lg:text-gray-900"
            >
              Pomoć
            </button>

            <div className="border-l border-gray-300 h-6 mx-2" />
            <button
              onClick={openModal}
              className="hidden lg:block lg:text-sm lg:font-semibold lg:leading-6 lg:text-gray-900"
            >
              Prijava
            </button>
            <button
              onClick={openModalRegister}
              className="rounded-md bg-transparent border border-black px-4 py-1 text-sm font-semibold text-black shadow-sm hover:bg-gray-200"
            >
              Registracija
            </button>
          </div>
        </nav>

        {/* Mobile Menu */}
        <Dialog
          className="lg:hidden"
          open={mobileMenuOpen}
          onClose={() => setMobileMenuOpen(false)}
        >
          <div className="fixed inset-0 z-50" />
          <DialogPanel className="fixed inset-y-0 right-0 z-50 w-full overflow-y-auto bg-white px-6 py-6 sm:max-w-sm sm:ring-1 sm:ring-gray-900/10">
            <div className="flex items-center justify-between">
              <a href="#" className="-m-1.5 p-1.5">
                <img
                  className="w-10"
                  src={`${process.env.PUBLIC_URL}/logoo.png`}
                  alt="Your Company"
                />
              </a>
              <button
                type="button"
                className="-m-2.5 rounded-md p-2.5 text-gray-700"
                onClick={() => setMobileMenuOpen(false)}
              >
                <XMarkIcon className="h-6 w-6" aria-hidden="true" />
              </button>
            </div>

            {/* Navigation Links */}
            <div className="mt-6 flow-root">
              <div className="-my-6 divide-y divide-gray-500/10">
                <div className="space-y-2 py-6">
                  {navigation.map((item) => (
                    <a
                      key={item.name}
                      href={item.href}
                      onClick={(e) => {
                        e.preventDefault();
                        if (item.name === "Priča") {
                          scrollToPricaMobile_();
                        } else if (item.name === "Blog") {
                          scrollToBlogMobile_();
                        } else if (item.name === "Pomoć") {
                          scrollToPomocMobile_();
                        }
                      }}
                      className="-mx-3 block rounded-lg px-3 py-2 text-base font-semibold leading-7 text-gray-900 hover:bg-gray-50"
                    >
                      {item.name}
                    </a>
                  ))}
                </div>

                {/* Mobile Log in / Sign up */}
                <div className="flex flex-col items-start gap-y-2">
                  <button
                    onClick={openModal}
                    className="mt-2 block text-base font-semibold leading-7 text-gray-900"
                  >
                    Prijava
                  </button>
                  <button
                    onClick={openModalRegister}
                    className="mt-2 block text-base font-semibold leading-7 text-gray-900"
                  >
                    Registracija
                  </button>
                </div>
              </div>
            </div>
          </DialogPanel>
        </Dialog>
      </header>

      {/* Modal za Login */}
      {showModal && (
        <div
          id="modal-overlay1"
          className="fixed inset-0 bg-gray-600 bg-opacity-50 flex items-center justify-center"
          onClick={handleOverlayClick}
        >
          {/* <div onClick={(e) => e.stopPropagation()} className="bg-white rounded-lg p-4"> */}
          <Login showModal={showModal} closeModal={closeModal} />
          {/* </div> */}
        </div>
      )}

      {/* Modal za Register */}
      {showModalRegister && (
        <div
          id="modal-overlay"
          className="fixed inset-0 bg-gray-600 bg-opacity-50 flex items-center justify-center"
          onClick={handleOverlayClick}
        >
          <div
            onClick={(e) => e.stopPropagation()}
            className="bg-white rounded-lg p-4"
          >
            <Register
              showModalRegister={showModalRegister}
              closeModalRegister={closeModalRegister}
            />
          </div>
        </div>
      )}
    </>
  );
};

export default LandingHeader;
